const regex = /\[[a-zA-Z]+]/g;

export const getUrlCategory = (pathname: string): string => {
  const str = pathname.replaceAll(regex, '').replaceAll('//', '');

  return str[str.length - 1] !== '/' ? str + '/' : str;
};
